"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M14.964 1.012a2.194 2.194 0 0 1 1.97 2.182v1.551a1.097 1.097 0 1 1-2.194 0v-1.55H5.21v17.61h9.53v-1.619a1.096 1.096 0 1 1 2.193 0v1.62l-.01.223a2.196 2.196 0 0 1-1.959 1.96L14.74 23H5.21l-.224-.012a2.195 2.195 0 0 1-1.96-1.959l-.01-.223V3.194c0-1.136.863-2.07 1.97-2.182L5.21 1h9.53l.224.012Z"
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M16.883 6.704c.13 0 .243.044.338.13a.522.522 0 0 1 .17.326l.156 1.212c.113.043.22.096.32.156.1.061.197.126.293.196l1.134-.47a.513.513 0 0 1 .651.208l.964 1.682c.07.112.091.235.065.365a.502.502 0 0 1-.195.312l-.978.742c.009.061.013.12.013.176v.352a.643.643 0 0 1-.025.177l.976.742a.5.5 0 0 1 .195.312.491.491 0 0 1-.064.366l-.965 1.666a.542.542 0 0 1-.664.222l-1.107-.469c-.096.07-.196.135-.3.196-.104.06-.209.113-.313.156l-.156 1.212a.52.52 0 0 1-.508.456h-1.955a.52.52 0 0 1-.508-.456l-.156-1.212a1.978 1.978 0 0 1-.32-.156 4.251 4.251 0 0 1-.292-.196l-1.134.47a.513.513 0 0 1-.651-.208l-.964-1.681a.49.49 0 0 1-.066-.366.5.5 0 0 1 .197-.312l.976-.742a1.252 1.252 0 0 1-.012-.177v-.352c0-.056.004-.115.012-.176l-.976-.742a.502.502 0 0 1-.197-.312.49.49 0 0 1 .066-.365l.964-1.681a.513.513 0 0 1 .651-.208l1.134.469a3.57 3.57 0 0 1 .3-.196 2.67 2.67 0 0 1 .312-.156l.157-1.212a.521.521 0 0 1 .17-.326.487.487 0 0 1 .337-.13h1.955Zm-.977 3.388a1.75 1.75 0 0 0-1.296.534 1.768 1.768 0 0 0-.528 1.289c0 .504.176.934.528 1.29.352.356.784.534 1.296.534.504 0 .934-.178 1.29-.534.356-.356.534-.786.534-1.29 0-.503-.178-.933-.534-1.289a1.758 1.758 0 0 0-1.29-.534Z",
      clipRule: "evenodd"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M10.811 4.255a.66.66 0 0 1 0 1.32H9.137a.66.66 0 0 1 0-1.32h1.674Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};